import {EphesoIncome} from './epheso-income';

export class PosizionePrevidenzialePregressa {
  code: string;
  start: any;
  end: any;
  refIncome: EphesoIncome;
}
